import { useEffect, useState } from "react";
import { client } from "../../../utils/axios-client";
import ChatClientStore, { Conversation } from "../stores/ChatClientStore";

const useChatClient = () => {
    const conversations = ChatClientStore.useState(s => s.conversations);
    const errorLoadingChats = ChatClientStore.useState(s => s.errorLoadingChats);
    const loadingConversations = ChatClientStore.useState(s => s.loadingConversations);
    const selectedChat = ChatClientStore.useState(s => s.selectedChat);
    const showChatWindow = ChatClientStore.useState(s => s.showChatWindow);
    const conversationId = ChatClientStore.useState(s => s.conversationId);
    const status = ChatClientStore.useState(s => s.status);
    const mode = ChatClientStore.useState(s => s.mode);

    const loadChats = async () => {
        var uri = `/api/conversations/me/${status}/${mode}`
        
        var chats = client.get<Conversation[]>(uri)
            .then(res => {
                ChatClientStore.update((s,o) => {
                    s.conversations = res.data;
                    s.loadingConversations = false;

                    if (o.selectedChat != null) {
                        const updatedChat = res.data.find(s => s.id === o.selectedChat!.id);
                        
                        if (updatedChat) {
                            s.selectedChat = updatedChat;
                        }
                    }
                })
            }).catch(err => {
                ChatClientStore.update(s => {                    
                   // s.errorLoadingChats = true;
                    s.loadingConversations = false;
                })
            });
    }

    const refreshChats = async () => {
        var uri = `/api/conversations/me/${status}/${mode}/updates`

        var chats = client.get<Conversation[]>(uri)
            .then(res => {
                ChatClientStore.update((s, o) => {
                    s.conversations = res.data;
                    s.loadingConversations = false;

                    var temp = structuredClone(o.conversations);

                    res.data.forEach((cn) => {
                        const updatedChatIndex = res.data.findIndex(s => s.id === cn.id);

                        if (updatedChatIndex > -1) {
                            temp[updatedChatIndex] = cn;
                        } else {
                            temp.push(cn);
                        }
                    });

                    if (o.selectedChat != null) {
                        const updatedChat = res.data.find(s => s.id === o.selectedChat!.id);

                        if (updatedChat) {
                            s.selectedChat = updatedChat;
                        }
                    }

                    s.conversations = temp;
                })
            }).catch(err => {
                ChatClientStore.update(s => {
                    
                    //s.errorLoadingChats = true;
                    s.loadingConversations = false;
                })
            });
    }

    const setSelectedConversation = (item: null | Conversation) => {
        ChatClientStore.update(s => {
            s.selectedChat = item;
            s.showChatWindow = item === null;
        })
    }

    const setShowChatWindow = () => {
        ChatClientStore.update(s => {
            s.selectedChat = null;
            s.showChatWindow = true;
        })
    }

    const requestHelp = async () => {
        const response = client.put(`/api/conversations/assistance/request/${conversationId}`)
    }

    const setStatus = (value: string) => {
        ChatClientStore.update(s => {
            s.status = value;
        });
    }

    const sendMessageAsync = async (message: string) => {
        const response = client.post(`/api/conversations/messages/send`, {
            message,
            conversationId: selectedChat?.id
        });
    }

    const updateStatus = async (status: string) => {
        const response = client.post('/api/conversations/messages/status/update', {
            status,
            conversationId: selectedChat?.id
        });        

        ChatClientStore.update((s,o) => {
            if (s.selectedChat != null) {
                const temp = structuredClone(selectedChat);
                if (temp) {
                    temp.status = status;
                    s.selectedChat = temp;

                    const temp2 = structuredClone(o.conversations);

                    const index = temp2.findIndex(s => s.id === selectedChat!.id);
                    if (index > -1 && temp2[index].status !== status) {
                        temp2.splice(index, 1);
                    }

                    s.conversations = temp2;
                }
            }
        })
    }


    return {
        loadChats,
        sendMessageAsync,
        selectedChat,
        errorLoadingChats,
        loadingConversations,
        conversations,
        setSelectedConversation,
        showChatWindow,
        setShowChatWindow,
        requestHelp,
        status,
        setStatus,
        updateStatus,
        refreshChats
    }
}

export default useChatClient;